import { Directive, HostListener } from '@angular/core';
import { FormDataValidityBaseDirective } from './form-data-validity-base.directive';

@Directive({
  standalone: true,
  selector: '[lxFormDataInputValidity]',
})
export class FormDataInputValidityDirective<T> extends FormDataValidityBaseDirective<T> {
  protected getNoFormDataWarningMessage(): string {
    return 'FormDataInputValidityDirective - Form data is not defined';
  }

  @HostListener('input')
  onInput() {
    if (this.enabledValidation$.value) {
      this.validation$.next();
    }
  }

  @HostListener('focusin')
  onFocusIn() {
    if (this.validationRequests > 0) {
      this.enabledValidation$.next(true);
    }
  }

  @HostListener('focusout')
  onFocusOut() {
    this.enabledValidation$.next(true);
  }
}
